import React, { useMemo, useState } from "react";
import { MdFolder, MdClose } from "react-icons/md";
import moment from "moment";
import Card from "../../../components/shared/Card/Card";
import Select from "../../../components/shared/Select/Select";
import Button from "../../../components/shared/Button/Button";
import CreateCollectionModal from "../../swing_library/components/Table/CollectionsRow/CreateCollectionModal";

export default function CollectionSelectorCard({
  cardColor = "blue",
  collection,
  collections = [],
  onRemove,
  onSelect,
  isQuickCompare = false,
}) {
  const [isCreateCollectionModalOpen, setIsCreateCollectionModalOpen] =
    useState(false);

  const selectOptions = useMemo(
    () =>
      (collections ?? []).map((c) => ({
        text: c?.collectionName,
        value: c?.id,
      })),
    [collections]
  );

  const swingsCount = collection?.videoIds?.length || 0;
  const updatedAt = collection?.updatedAt || collection?.createdAt;

  if (!collection && !isQuickCompare) {
    return (
      <Card
        borderColor="primary800"
        borderStyle="dashed"
        className="flex flex-col items-center justify-center gap-2 p-6 min-h-[152px]"
        color="primary50"
        rounded="xl"
      >
        <Select
          btnInitialColor="primary500"
          header="Collections"
          menuClassName="w-full min-w-[200px]"
          onChange={(value) => onSelect(value)}
          options={selectOptions}
          placeholder="Select Collection"
          withSearch={true}
        />
      </Card>
    );
  }

  if (!collection && isQuickCompare) {
    return (
      <Card
        borderColor={cardColor === "blue" ? "blue700" : "pink700"}
        className="relative flex flex-col gap-2 px-6 py-3"
        color={cardColor === "blue" ? "blue50" : "pink50"}
        rounded="xl"
      >
        <MdFolder className="text-blueLight300 size-6" />

        <div className="text-gray900 truncate text-sm font-semibold">
          Selecting swings...
        </div>
      </Card>
    );
  }

  return (
    <>
      <Card
        borderColor={cardColor === "blue" ? "blue700" : "pink700"}
        className="relative flex flex-col gap-2 px-6 py-3"
        color={cardColor === "blue" ? "blue50" : "pink50"}
        rounded="xl"
      >
        {onRemove && (
          <Button
            className="absolute -top-2 -right-2"
            color="white/gray300"
            isIconOnly
            onClick={onRemove}
            rounded="full"
            size="xxs"
          >
            <MdClose className="text-gray700 size-3" />
          </Button>
        )}

        <MdFolder className="text-blueLight300 size-6" />

        <div className="text-gray900 truncate text-sm font-semibold">
          {collection?.collectionName}
        </div>
        <div className="text-sm font-semibold">
          <span className="text-gray900">
            {swingsCount} {swingsCount === 1 ? "swing" : "swings"}
          </span>{" "}
          {updatedAt && !isQuickCompare && (
            <span className="text-grayTrue600">
              - Last updated {moment(updatedAt).fromNow()}
            </span>
          )}
        </div>

        {onSelect && selectOptions && !isQuickCompare ? (
          <Select
            btnSelectedColor="transparent/primary700"
            className="w-full"
            header="Collections"
            onChange={(value) => onSelect(value)}
            options={selectOptions}
            placeholder="Change"
            showSelectedText={false}
            value={collection?.id}
            withSearch={true}
          />
        ) : (
          <div
            className="text-sm underline text-primary700 hover:text-primary500 cursor-pointer"
            onClick={() => setIsCreateCollectionModalOpen(true)}
          >
            Save as collection
          </div>
        )}
      </Card>

      <CreateCollectionModal
        isOpen={isCreateCollectionModalOpen}
        onClose={() => setIsCreateCollectionModalOpen(false)}
        videoIds={collection?.videoIds}
      />
    </>
  );
}
